// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.addressBlock-background {
  background: #636161;
  border-radius: 10px;
  width: 550px;
  padding: 10px 40px;
  color: white;
}
.addressBlock-background .address-block-label {
  font-size: 1.05rem;
  font-weight: 550;
}
.addressBlock-background .email-container {
  display: flex;
  align-items: center;
}
.addressBlock-background .email-container .email-label {
  font-size: 0.95rem;
  color: white;
  font-weight: 600;
}
.addressBlock-background .email-container .email {
  color: white;
  padding-left: 10px;
  font-size: 0.85rem;
  font-weight: 510;
}
.addressBlock-background .address-container {
  display: flex;
}
.addressBlock-background .address-container .address-label {
  font-size: 0.95rem;
  color: white;
  font-weight: 600;
}
.addressBlock-background .address-container .address {
  color: white;
  padding-left: 10px;
  font-size: 0.85rem;
  font-weight: 510;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/AddressBlock.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,mBDmBI;EEpBJ,mBDEsB;EACtB,YAAA;EACA,kBAAA;EACA,YAAA;AAUJ;AARI;EACI,kBAAA;EACA,gBAAA;AAUR;AARI;EACI,aAAA;EACA,mBAAA;AAUR;AARQ;EACI,kBAAA;EACA,YAAA;EACA,gBAAA;AAUZ;AARQ;EACI,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAUZ;AAPI;EACI,aAAA;AASR;AAPQ;EACI,kBAAA;EACA,YAAA;EACA,gBAAA;AASZ;AAPQ;EACI,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AASZ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// Open Enrollment colors\n$lt-blue: #7DB7CC;\n// $dk-blue: #094166;\n$dk-blue: #19608f;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$dk-pearl-blue: #065b9d;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.addressBlock-background {\n    background: $grey4;\n    @include borderRadius(10px);\n    width: 550px;\n    padding: 10px 40px;\n    color: white;\n    \n    .address-block-label {\n        font-size: 1.05rem;\n        font-weight: 550;\n    }\n    .email-container {\n        display: flex;\n        align-items: center;\n\n        .email-label {\n            font-size: .95rem;\n            color: white;\n            font-weight: 600;\n        }\n        .email {\n            color: white;\n            padding-left: 10px;\n            font-size: .85rem;\n            font-weight: 510;\n        }\n    }\n    .address-container {\n        display: flex;\n\n        .address-label {\n            font-size: .95rem;\n            color: white;\n            font-weight: 600;\n        }\n        .address {\n            color: white;\n            padding-left: 10px;\n            font-size: .85rem;\n            font-weight: 510;\n        }\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
